import React from 'react';
import { Button } from '../../../../components/_base/Button';
import Icon from '../../../../components/_base/Icon';
import { useNavigationLogic } from './useNavigationLogic';

interface MeetingDetailsNavigationProps {
  showTopNavBtns?: boolean;
  agendaLabel?: string;
}

const MeetingDetailsNavigation: React.FC<MeetingDetailsNavigationProps> = ({
  showTopNavBtns,
  agendaLabel
}) => {
  const { navigationLabel, backToList } = useNavigationLogic({ agendaLabel });

  if (!showTopNavBtns) return null;

  return (
    <>
      <div className='px-8 pb-8'>
        <Button
          name='backToList'
          type='button'
          className='py-1 px-2 rounded-md text-primary bg-transparent on-hover-shadow'
          onClick={backToList}
          label={
            <>
              <span className='pr-1'>
                <Icon.RightArrow
                  className='mb-1 fill-primary transform rotate-180'
                  width='15px'
                  height='15px'
                  aria-hidden='true'
                  titleId='back button'
                  title='back button'
                  descId='desc for back button'
                  desc='button to navigate back to the previous page'
                />
              </span>
              <span className='font-size-13px'>{navigationLabel}</span>
            </>}
        >
        </Button>
      </div>
      <hr />
    </>
  );
};

export default MeetingDetailsNavigation;
